import { render, staticRenderFns } from "./bcgsbjsljl.vue?vue&type=template&id=06e8910c&scoped=true&"
import script from "./bcgsbjsljl.vue?vue&type=script&lang=js&"
export * from "./bcgsbjsljl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8910c",
  null
  
)

export default component.exports